import {
  Box,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";

import MDBox from "components/MDBox";
import MDBadge from "components/MDBadge";
import TagColorChip from "components/TagColorChip";

//icones
// import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
// import CreditScoreOutlinedIcon from "@mui/icons-material/CreditScoreOutlined";
import EditIcon from "@mui/icons-material/Edit";
import CopyAllIcon from "@mui/icons-material/CopyAll";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import { IDistanciaEvento } from "interfaces/eventos";
import { Fragment, useState } from "react";
import { getValueLote } from "helpers/getValueLote";
import { ILotes } from "interfaces/lotes";
import MDDialog from "components/MDDialog";
import { deleteCategoriaDistancia } from "services/evento";
import { SelectedDistanciaProps } from "./";
import { setMessage, useMaterialUIController } from "context";
import { getcolorBadge } from "helpers/colorBadge";

interface Props {
  distancias: IDistanciaEvento[];
  lotesEvento: ILotes[];
  updateEvento: () => void;
  selectedDistancia: (distancia: SelectedDistanciaProps) => void;
}
export default function ListCatDist({
  distancias,
  lotesEvento,
  updateEvento,
  selectedDistancia,
}: Props) {
  const [, dispatch] = useMaterialUIController();
  return (
    <Table sx={{ minWidth: 650 }} aria-label="caption table">
      <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
        <TableCell width="40%">Descrição</TableCell>
        <TableCell>Distância</TableCell>
        <TableCell align="center">Camiseta</TableCell>
        <TableCell align="right">Limite</TableCell>
        <TableCell align="center">Ações</TableCell>
      </TableRow>

      <TableBody>
        {distancias.map((row, idx) => (
          <Row
            dispatch={dispatch}
            key={idx}
            row={row}
            lotes={lotesEvento}
            isUpdate={updateEvento}
            selected={selectedDistancia}
          />
        ))}
      </TableBody>
    </Table>
  );
}

const Row = ({
  dispatch,
  row,
  lotes,
  isUpdate,
  selected,
}: {
  dispatch: any;
  row: IDistanciaEvento;
  lotes: ILotes[];
  isUpdate: () => void;
  selected: (distancia: SelectedDistanciaProps) => void;
}) => {
  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState<boolean>(false);

  // TODO: fazer a exclusão de uma distância e categorias
  const handleDeleteCatDist = async (catDistId: number) => {
    const { status } = await deleteCategoriaDistancia(catDistId);
    if (status === 200) {
      isUpdate();
    } else {
      setMessage(dispatch, {
        open: true,
        text: "Existe atleta cadastrado nesta distância/Categoria",
        severity: "error",
      });
    }
    setOpenDialog(!openDialog);
  };

  return (
    <Fragment>
      <TableRow
        sx={{
          "& > *": {
            borderBottom: "unset",
            backgroundColor: open ? "orange" : "",
          },
        }}
      >
        <TableCell component="th">
          <MDBox display="flex" alignItems="center" gap={2}>
            <IconButton onClick={() => setOpen(!open)}>
              {open ? (
                <KeyboardArrowDownOutlinedIcon fontSize="medium" />
              ) : (
                <KeyboardArrowUpOutlinedIcon fontSize="medium" />
              )}
            </IconButton>
            <MDBox>
              <Tooltip title={row.descricao}>
                <Typography variant="h6" color="textSecondary">
                  {row.descricao}
                </Typography>
              </Tooltip>
              <Typography variant="caption" color="textSecondary">
                {row.categoriaEvento.length} Categorias
              </Typography>
            </MDBox>
          </MDBox>
        </TableCell>
        <TableCell align="center" component="th">
          <MDBadge
            variant="gradient"
            size="sm"
            badgeContent={`${row.distancia} ${row.unidade}`}
            color="success"
            container
          />
        </TableCell>
        <TableCell align="center" component="th">
          <MDBadge
            variant="gradient"
            size="sm"
            badgeContent={row.incluiCamiseta === false ? "Sem camiseta" : "Com camiseta"}
            color={row.incluiCamiseta === false ? "secondary" : "info"}
            container
          />
        </TableCell>
        <TableCell align="right" component="th">
          <p className="font-bold">{row.qtdLimite}</p>
        </TableCell>
        <TableCell align="center">
          <Tooltip title="Editar distância">
            <IconButton
              onClick={() => selected({ type: "edit", distCat: row })}
            >
              <EditIcon fontSize="small" color="info" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Excluir Distância">
            <IconButton onClick={() => setOpenDialog(!openDialog)}>
              <DeleteOutlineIcon fontSize="small" color="error" />
            </IconButton>
          </Tooltip>
          <MDDialog
            title="🗑️ Excluir distância"
            message={`Deseja excluir a distância "${row.descricao}"`}
            open={openDialog}
            onClose={() => setOpenDialog(!openDialog)}
            response={(resp: boolean) =>
              resp ? handleDeleteCatDist(row.id) : setOpenDialog(!openDialog)
            }
          />
          <Tooltip title="Clonar distância">
            <IconButton
              onClick={() => selected({ type: "clone", distCat: row })}
            >
              <CopyAllIcon fontSize="small" color="info" />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={5}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Descrições das categorias
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                  <TableCell sx={{ fontWeight: "bold" }}>Sexo</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Descrição</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="center">
                    Faixa etária
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="center">
                    Tag
                  </TableCell>
                </TableRow>

                <TableBody>
                  {row.categoriaEvento.map((row, idx) => (
                    <TableRow
                      key={row.id}
                      sx={{
                        "& > *": { borderBottom: "1px solid #f5f5f5" },
                        "&:hover": {
                          backgroundColor: "#f1f1f1",
                          cursor: "pointer",
                        },
                      }}
                    >
                      <TableCell>
                        <MDBadge
                          variant="gradient"
                          size="sm"
                          badgeContent={`${idx + 1} `}
                          color="light"
                          container
                        />{" "}
                        {row.sexo.tipo}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {row.descricao}
                      </TableCell>
                      <TableCell align="center">
                        {row.idadeInicial}~{row.idadefinal}
                      </TableCell>
                      <TableCell align="center">
                        <TagColorChip
                          tipo={row.tag.tipo}
                          cor={(row.tag as { cor?: string }).cor}
                          label={getValueLote(lotes, row.tag.tipo)}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
};
